import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const CheckoutCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      <XCircle className="w-16 h-16 text-neutral-400 mx-auto" />
      <h1 className="text-3xl font-black mt-6">Checkout cancelled</h1>
      <p className="text-neutral-600 mt-2">Your card was not charged. Your cart is still saved.</p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <Button onClick={() => navigate('/shop')} className="bg-[#0a0a0a] hover:bg-neutral-800">Back to Shop</Button>
        <Button variant="outline" onClick={() => navigate('/')}>Home</Button>
      </div>
    </div>
  );
};

export default CheckoutCancel;
